// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-role-relations .fi-role-relations-content-wrap {
  padding-top: 30px;
}
.fi-role-relations .fi-role-relations-content-wrap .fi-edit-page-content {
  max-width: 970px;
}
.fi-role-relations .fi-role-relations-content-wrap .mat-mdc-card.main-card {
  padding: 0;
  border-radius: 10px;
  max-width: 80%;
  margin: 0 auto 20px;
}
@media screen and (min-width: 1200px) {
  .fi-role-relations .fi-role-relations-content-wrap .mat-mdc-card.main-card {
    max-width: 850px;
  }
}
.fi-role-relations .fi-role-relations-content-wrap .mat-mdc-card.main-card .mat-mdc-card-header {
  border-radius: 10px 10px 0 0;
  padding: 10px 20px;
  font-size: 22px;
  line-height: 32px;
}
.fi-role-relations .fi-role-relations-content-wrap .mat-mdc-card.main-card .mat-mdc-card-content {
  padding: 25px 20px 30px;
  font-size: 16px;
}
.fi-role-relations .fi-role-relations-content-wrap .mat-mdc-card.main-card .mat-mdc-card-content .mat-icon {
  font-size: 20px;
  text-align: center;
  line-height: 24px;
  vertical-align: middle;
  margin-right: 10px;
}
.fi-role-relations .fi-role-relations-content-wrap .mat-mdc-card.main-card .mat-mdc-card-content .extended-sharing-content-heading {
  vertical-align: middle;
  font-weight: 500;
}
.fi-role-relations .fi-role-relations-content-wrap .fi-extend-sharing-object {
  width: 100%;
  padding-top: 0;
  padding-bottom: 20px;
}
.fi-role-relations .fi-role-relations-content-wrap .fi-extend-sharing-object .mat-mdc-card {
  width: 100%;
  border-radius: 10px;
  border-top: 10px solid;
  margin: 0 0 20px;
}
.fi-role-relations .fi-role-relations-content-wrap .fi-extend-sharing-object .mat-mdc-card .fa-user-gear {
  width: 32px;
}
.fi-role-relations .fi-role-relations-content-wrap .mat-mdc-card {
  margin: 0 10px 10px 10px;
}
.fi-role-relations .fi-role-relations-content-wrap .mat-mdc-card.fi-role-relations_card_1 {
  padding-bottom: 48px;
}
.fi-role-relations .fi-role-relations-content-wrap .mat-mdc-card fi-info-icon {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/role/role-relations/role-relations.component.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;AAAR;AAEQ;EACI,gBAAA;AAAZ;AAIY;EACI,UAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAFhB;AAIgB;EANJ;IAOQ,gBAAA;EADlB;AACF;AAEgB;EACI,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAApB;AAGgB;EACI,uBAAA;EACA,eAAA;AADpB;AAGoB;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AADxB;AAIoB;EACI,sBAAA;EACA,gBAAA;AAFxB;AAQQ;EACI,WAAA;EACA,cAAA;EACA,oBAAA;AANZ;AAQY;EACI,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AANhB;AAOgB;EACI,WAAA;AALpB;AAUQ;EAKI,wBAAA;AAZZ;AAQY;EACI,oBAAA;AANhB;AAWY;EACI,iBAAA;AAThB","sourcesContent":[".fi-role-relations {\r\n    .fi-role-relations-content-wrap {\r\n        padding-top: 30px;\r\n\r\n        .fi-edit-page-content {\r\n            max-width: 970px;\r\n        }\r\n\r\n        .mat-mdc-card {\r\n            &.main-card {\r\n                padding: 0;\r\n                border-radius: 10px;\r\n                max-width: 80%;\r\n                margin: 0 auto 20px;\r\n\r\n                @media screen and (min-width: 1200px) {\r\n                    max-width: 850px;\r\n                }\r\n                .mat-mdc-card-header {\r\n                    border-radius: 10px 10px 0 0;\r\n                    padding: 10px 20px;\r\n                    font-size: 22px;\r\n                    line-height: 32px;\r\n                }\r\n\r\n                .mat-mdc-card-content {\r\n                    padding: 25px 20px 30px;\r\n                    font-size: 16px;\r\n\r\n                    .mat-icon {\r\n                        font-size: 20px;\r\n                        text-align: center;\r\n                        line-height: 24px;\r\n                        vertical-align: middle;\r\n                        margin-right: 10px;\r\n                    }\r\n\r\n                    .extended-sharing-content-heading {\r\n                        vertical-align: middle;\r\n                        font-weight: 500;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .fi-extend-sharing-object {\r\n            width: 100%;\r\n            padding-top: 0;\r\n            padding-bottom: 20px;\r\n\r\n            .mat-mdc-card {\r\n                width: 100%;\r\n                border-radius: 10px;\r\n                border-top: 10px solid;\r\n                margin: 0 0 20px;\r\n                .fa-user-gear {\r\n                    width: 32px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .mat-mdc-card {\r\n            &.fi-role-relations_card_1 {\r\n                padding-bottom: 48px;\r\n            }\r\n\r\n            margin: 0 10px 10px 10px;\r\n\r\n            fi-info-icon {\r\n                margin-left: 10px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
